import script from "./PortfolioLimitsComposiciones.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioLimitsComposiciones.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioLimitsComposiciones.vue?vue&type=style&index=0&id=2c826da2&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c826da2"]])

export default __exports__